/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, shape, string,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';

import AccountLeftMenu from '../../../../common/Desktop/AccountLeftMenu';
import CustomerNumber from './RegularUser/Forms/CustomerNumber';
import getSiteConfig from '../../../../utils/getSiteConfig';
import Image from '../../../../common/Image';
import { getIsBigGiftList } from '../../../../state/ducks/Common/Common-Selectors';

const styles = (theme) => ({
    container: {
        width: '100%',
        maxWidth: '1440px',
        margin: 'auto',
    },
    contentGrid: {
        marginTop: 24,
        marginBottom: 24,
        display: 'flex',
        width: '47%',
    },
    block: {
        flex: 1,
        border: `${'1px solid'} ${theme.palette.myAccount.contentGridBorder}`,
        marginRight: 12,
        marginLeft: 12,
        borderRadius: 2,
        '&:first-child': {
            marginLeft: 0,
        },
        '&.separator': {
            flex: 'none',
            width: 24,
            border: 'none',
            textAlign: 'center',
            marginTop: 12,
        },
        '&:last-child': {
            marginRight: 0,
        },
    },
    blockHeader: {
        backgroundColor: theme.palette.grey7,
        color: theme.palette.myAccount.blockMessageFadedInside,
        textTransform: 'uppercase',
        padding: '10px 10px',
        fontWeight: 600,
        borderRadius: 2,
    },
    blockContent: {
        padding: '12px 48px',
        minHeight: 150,
        lineHeight: 1.5,
        '&.guest': {
            marginTop: 24,
            textAlign: 'center',
        },
        '& .giftListButton': {
            float: 'none !important',
            margin: 0,
        },
    },
});

const DesktopRegularUser = ({ classes, userProfile, featureFlags }) => {
    const isBigGiftlist = useSelector(getIsBigGiftList);
    const hasBrandSpecific = getSiteConfig('phoneNumber')?.props?.children?.includes('1-877-322-1200');

    return (
        <div className={classes.container}>
            <Grid container>
                <AccountLeftMenu
                    userProfile={userProfile}
                    featureFlags={featureFlags}
                />
                <Grid item xs={10} style={{ padding: '40px 11px 0 43px' }}>
                    <h2>YOUR GIFT LIST</h2>
                    {isBigGiftlist ? (
                        <div>
                            Wow, your gift list is too big to display online. Please contact customer service for assistance {getSiteConfig('phoneNumber')}
                        </div>
                    ) : (
                        <>
                            <p className="margin-top-2x">
                                We’re sorry. We cannot find a Gift List with your email
                                address. Please try using one of the options below, or call
                                us at {getSiteConfig('phoneNumber')}.
                            </p>
                            <p>
                                If you have a catalog, you can find your customer number on
                                the back.
                            </p>
                            <div className={classes.contentGrid}>
                                <div className={classes.block}>
                                    <div className={classes.blockHeader}>Option A: Enter Customer Number</div>
                                    <div className={classes.blockContent}>
                                        {hasBrandSpecific && (
                                            <Image
                                                className="margin-top"
                                                src="//cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/customer-number.png"
                                                alt=""
                                            />
                                        )}
                                        <CustomerNumber hasBrandSpecific={hasBrandSpecific} />
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </Grid>
            </Grid>
        </div>
    );
};

DesktopRegularUser.defaultProps = {
    userProfile: {},
    featureFlags: {},
};

DesktopRegularUser.propTypes = {
    classes: object.isRequired,
    userProfile: shape({
        userRole: string,
        email: string,
        XAtt4: string,
        XAtt5: string,
    }),
    featureFlags: object,
};

export default withStyles(styles)(DesktopRegularUser);
